/**
 * Home feed UI without Google Maps: carousels, hide/unhide, details modal, type filters.
 * Globe interactions live in home-globe.js (`cpHomeGlobeReload`, `cpHomeGlobeClearFocus`).
 */
(function () {
    var INTERACTIVE_OUTSIDE_GLOBE =
        'a, button, input, select, textarea, label, form, [role="button"]';

    function readConfig() {
        var el = document.getElementById('cp-home-feed-config');
        if (!el || !String(el.textContent || '').trim()) {
            return {};
        }
        try {
            return JSON.parse(el.textContent);
        } catch (_e) {
            return {};
        }
    }

    var cfg = readConfig();
    var isLoggedIn = !!cfg.isLoggedIn;
    var saveHiddenCardsUrl = cfg.saveHiddenCardsUrl || '';
    var csrfMeta = document.querySelector('meta[name="csrf-token"]');
    var csrfToken = csrfMeta ? csrfMeta.getAttribute('content') || '' : '';
    var hiddenPostIds = new Set(
        (cfg.initialHiddenPostIds || [])
            .map(function (id) {
                return parseInt(id, 10);
            })
            .filter(Number.isFinite)
    );
    var saveHiddenTimer = null;
    var HIDDEN_MARKER_IDS_KEY = 'cp_home_hidden_marker_ids';
    var detailsOverlay = document.getElementById('cp-details-overlay');
    var detailsFrame = document.getElementById('cp-details-frame');
    var detailsTitle = document.getElementById('cp-details-title');
    var detailsCloseBtn = document.getElementById('cp-details-close');
    var hiddenCategories = {
        event: false,
        trail: false,
        product: false,
        business: false,
        track: false,
        compare: false,
    };

    function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }

    function readCssPixels(name, fallback) {
        var raw = getComputedStyle(document.documentElement)
            .getPropertyValue(name)
            .trim();
        var parsed = parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }

    function getHomeCarouselItems(carousel) {
        var viewport =
            carousel.querySelector('.cp-home-multi-carousel__viewport') ||
            carousel;
        var available =
            viewport.clientWidth || carousel.clientWidth || window.innerWidth;
        var cardMax = readCssPixels('--cp-card-max-width', 360);
        var gap = 14;

        if (window.innerWidth < 992) {
            return 1;
        }

        return clamp(
            Math.floor((available + gap) / (cardMax + gap)),
            2,
            6
        );
    }

    function refreshHomeCarousels() {
        document
            .querySelectorAll('[data-cp-home-responsive-carousel]')
            .forEach(function (carousel) {
                var items = getHomeCarouselItems(carousel);
                var current = parseInt(
                    carousel.getAttribute('data-cp-items') || '0',
                    10
                );

                if (
                    current === items &&
                    window.MultiCarousel &&
                    typeof window.MultiCarousel.getInstance === 'function' &&
                    window.MultiCarousel.getInstance(carousel)
                ) {
                    return;
                }

                carousel.setAttribute('data-cp-items', String(items));

                if (!window.MultiCarousel || typeof window.MultiCarousel !== 'function') {
                    return;
                }

                try {
                    if (typeof window.MultiCarousel.getInstance === 'function') {
                        var existing = window.MultiCarousel.getInstance(carousel);
                        if (existing && typeof existing.dispose === 'function') {
                            existing.dispose();
                        }
                    }

                    new window.MultiCarousel(carousel).init();
                } catch (_e) {
                    /* Carousel helper may still be loading */
                }
            });
    }

    window.CpHomeResponsiveCarousels = refreshHomeCarousels;
    window.addEventListener('load', refreshHomeCarousels);
    window.addEventListener('resize', function () {
        clearTimeout(window.CpHomeResponsiveCarouselTimer);
        window.CpHomeResponsiveCarouselTimer = setTimeout(
            refreshHomeCarousels,
            120
        );
    });

    if (window.MutationObserver) {
        new MutationObserver(function (mutations) {
            var shouldRefresh = mutations.some(function (mutation) {
                return Array.prototype.some.call(
                    mutation.addedNodes || [],
                    function (node) {
                        return (
                            node.nodeType === 1 &&
                            ((node.matches &&
                                node.matches(
                                    '[data-cp-home-responsive-carousel]'
                                )) ||
                                (node.querySelector &&
                                    node.querySelector(
                                        '[data-cp-home-responsive-carousel]'
                                    )))
                        );
                    }
                );
            });

            if (shouldRefresh) {
                setTimeout(refreshHomeCarousels, 0);
            }
        }).observe(document.body, { childList: true, subtree: true });
    }

    function findCardEl(postId) {
        return document.querySelector(
            '.card[data-post-id="' + postId + '"]'
        );
    }

    function loadHiddenMarkerIds() {
        try {
            var raw = localStorage.getItem(HIDDEN_MARKER_IDS_KEY);
            if (!raw) return [];
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed.map(String) : [];
        } catch (_e) {
            return [];
        }
    }

    function saveHiddenMarkerIds(ids) {
        try {
            localStorage.setItem(HIDDEN_MARKER_IDS_KEY, JSON.stringify(ids));
        } catch (_e) {
            /* ignore quota */
        }
    }

    function findMarkerHideWrapper(btn) {
        return (
            btn.closest('.cp-card-col') ||
            btn.closest('.cp-map-ad') ||
            btn.closest('#cp-section-businesses .col-12')
        );
    }

    function applyHiddenMarkersFromStorage() {
        var ids = new Set(loadHiddenMarkerIds().map(String));
        if (!ids.size) return;
        document.querySelectorAll('.card[data-map-marker-id]').forEach(function (card) {
            var mid = card.dataset.mapMarkerId;
            if (!mid || !ids.has(String(mid))) return;
            var wrap =
                card.closest('.cp-card-col') ||
                card.closest('.cp-map-ad') ||
                card.closest('#cp-section-businesses .col-12');
            if (wrap) wrap.classList.add('cp-card-is-hidden');
        });
    }

    function findCardCol(cardEl) {
        return cardEl
            ? cardEl.closest('.cp-card-col') || cardEl.parentElement
            : null;
    }

    function sectionForCard(cardEl) {
        var feedCol = cardEl
            ? cardEl.closest('[data-home-feed-type]')
            : null;
        if (feedCol) {
            return feedCol.getAttribute('data-home-feed-type');
        }
        return null;
    }

    function hiddenCardsForSection(sectionCategory) {
        return Array.from(hiddenPostIds)
            .map(function (id) {
                return findCardEl(id);
            })
            .filter(function (card) {
                return !!card && sectionForCard(card) === sectionCategory;
            });
    }

    function renderHiddenDropdowns() {
        ['event', 'trail', 'product'].forEach(function (sectionCategory) {
            var dropdown = document.querySelector(
                '[data-hidden-section="' + sectionCategory + '"]'
            );
            var listEl = document.querySelector(
                '[data-hidden-list="' + sectionCategory + '"]'
            );
            if (!dropdown || !listEl) return;

            var countEl = dropdown.querySelector('.cp-hidden-count');
            var hiddenCards = hiddenCardsForSection(sectionCategory);
            if (countEl) countEl.textContent = String(hiddenCards.length);

            listEl.innerHTML = '';
            if (hiddenCards.length === 0) {
                var empty = document.createElement('div');
                empty.className = 'cp-hidden-empty';
                empty.textContent = 'No hidden cards';
                listEl.appendChild(empty);
                return;
            }

            hiddenCards.forEach(function (card) {
                var id = parseInt(card.dataset.postId, 10);
                if (!Number.isFinite(id)) return;
                var item = document.createElement('div');
                item.className = 'cp-hidden-item';
                item.innerHTML =
                    '<span class="cp-hidden-item-title">' +
                    escapeHtml(card.dataset.postTitle || 'Post #' + id) +
                    '</span>' +
                    '<button type="button" class="btn btn-sm btn-success js-card-unhide" data-post-id="' +
                    id +
                    '">Unhide</button>';
                listEl.appendChild(item);
            });
        });
    }

    function setCardHiddenState(postId, hidden, options) {
        options = options || {};
        var card = findCardEl(postId);
        if (!card) return;
        var col = findCardCol(card);

        if (hidden) {
            hiddenPostIds.add(postId);
            if (col) col.classList.add('cp-card-is-hidden');
        } else {
            hiddenPostIds.delete(postId);
            if (col) col.classList.remove('cp-card-is-hidden');
        }

        renderHiddenDropdowns();
        if (!options.skipPersist) {
            persistHiddenCards();
        }
    }

    function persistHiddenCards() {
        if (!isLoggedIn || !saveHiddenCardsUrl || !csrfToken) return;
        if (saveHiddenTimer) window.clearTimeout(saveHiddenTimer);
        saveHiddenTimer = window.setTimeout(function () {
            fetch(saveHiddenCardsUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify({
                    hidden_post_ids: Array.from(hiddenPostIds),
                }),
            }).catch(function () {});
        }, 280);
    }

    function applyHiddenCardsToDom() {
        Array.from(hiddenPostIds).forEach(function (id) {
            setCardHiddenState(id, true, { skipPersist: true });
        });
        renderHiddenDropdowns();
    }

    function withGlassParam(url) {
        try {
            var parsed = new URL(url, window.location.href);
            parsed.searchParams.set('cp_glass', '1');
            return parsed.toString();
        } catch (_e) {
            return url + (String(url).indexOf('?') === -1 ? '?' : '&') + 'cp_glass=1';
        }
    }

    function openDetailsModal(url, title) {
        if (!detailsOverlay || !detailsFrame || !url) return;
        detailsFrame.src = withGlassParam(url);
        if (detailsTitle) detailsTitle.textContent = title || 'More details';
        detailsOverlay.classList.remove('d-none');
        detailsOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function closeDetailsModal() {
        if (!detailsOverlay || !detailsFrame) return;
        detailsOverlay.classList.add('d-none');
        detailsOverlay.setAttribute('aria-hidden', 'true');
        detailsFrame.src = 'about:blank';
        document.body.style.overflow = '';
    }

    function homeTypeLabel(category) {
        if (category === 'event') return 'Events';
        if (category === 'trail') return 'Trails';
        if (category === 'product') return 'Items for Sale';
        return 'Posts';
    }

    function applyHomeFeedTypeVisibility() {
        document.querySelectorAll('[data-home-feed-type]').forEach(function (col) {
            var category = col.getAttribute('data-home-feed-type');
            if (!category || category === 'sponsored') return;
            col.classList.toggle(
                'cp-card-type-hidden',
                !!hiddenCategories[category]
            );
        });
    }

    function renderHiddenTypeBar() {
        var bar = document.getElementById('cp-hidden-type-bar');
        if (!bar) return;

        bar.innerHTML = '';
        ['event', 'trail', 'product'].forEach(function (category) {
            if (!hiddenCategories[category]) return;

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'btn btn-sm btn-success js-home-type-visibility';
            btn.setAttribute('data-home-feed-type', category);
            btn.setAttribute('data-action', 'show');
            btn.innerHTML =
                '<i class="fas fa-eye me-1"></i>Show ' +
                escapeHtml(homeTypeLabel(category));
            bar.appendChild(btn);
        });

        if (!bar.children.length) {
            var empty = document.createElement('span');
            empty.className = 'text-muted small';
            empty.textContent = 'No hidden types';
            bar.appendChild(empty);
        }
    }

    function setHomeFeedTypeHidden(category, hidden) {
        if (!Object.prototype.hasOwnProperty.call(hiddenCategories, category)) {
            return;
        }
        hiddenCategories[category] = !!hidden;
        applyHomeFeedTypeVisibility();
        renderHiddenTypeBar();
    }

    function escapeHtml(value) {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    document.addEventListener('click', function (e) {
        var shareBtn = e.target.closest('.js-cp-card-share');
        if (shareBtn) {
            e.preventDefault();
            e.stopPropagation();
            var shareUrl =
                shareBtn.getAttribute('data-share-url') || window.location.href;
            var shareTitle =
                shareBtn.getAttribute('data-share-title') || document.title;
            if (navigator.share) {
                navigator.share({ title: shareTitle, url: shareUrl }).catch(
                    function () {}
                );
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(shareUrl).catch(function () {
                    window.prompt('Copy link', shareUrl);
                });
            } else {
                window.prompt('Copy link', shareUrl);
            }
            return;
        }

        var hideMrk = e.target.closest('.js-cp-marker-hide');
        if (hideMrk) {
            e.preventDefault();
            e.stopPropagation();
            var hid = hideMrk.getAttribute('data-marker-id');
            if (!hid) return;
            var hidList = loadHiddenMarkerIds().map(String);
            if (hidList.indexOf(String(hid)) === -1) {
                hidList.push(String(hid));
                saveHiddenMarkerIds(hidList);
            }
            var wrap = findMarkerHideWrapper(hideMrk);
            if (wrap) wrap.classList.add('cp-card-is-hidden');
            return;
        }

        var detailsBtn = e.target.closest('.js-card-more-details');
        if (detailsBtn) {
            e.preventDefault();
            e.stopPropagation();
            var detailsUrl = detailsBtn.getAttribute('data-post-url');
            var detailsText =
                detailsBtn.getAttribute('data-post-title') || 'More details';
            openDetailsModal(detailsUrl, detailsText);
            return;
        }

        var hideBtn = e.target.closest('.js-card-hide');
        if (hideBtn) {
            e.preventDefault();
            e.stopPropagation();
            var hideId = parseInt(hideBtn.getAttribute('data-post-id'), 10);
            if (Number.isFinite(hideId)) {
                setCardHiddenState(hideId, true);
            }
            return;
        }

        var unhideBtn = e.target.closest('.js-card-unhide');
        if (unhideBtn) {
            e.preventDefault();
            e.stopPropagation();
            var unhideId = parseInt(unhideBtn.getAttribute('data-post-id'), 10);
            if (Number.isFinite(unhideId)) {
                setCardHiddenState(unhideId, false);
            }
            return;
        }

        if (
            detailsOverlay &&
            !detailsOverlay.classList.contains('d-none')
        ) {
            if (
                e.target === detailsOverlay ||
                e.target.closest('#cp-details-close')
            ) {
                e.preventDefault();
                closeDetailsModal();
                return;
            }
        }

        if (
            !e.target.closest(INTERACTIVE_OUTSIDE_GLOBE) &&
            !e.target.closest('.js-home-globe-feed-item') &&
            !e.target.closest('#home-globe') &&
            !e.target.closest('.cp-home-globe-chrome') &&
            !e.target.closest('.cp-globe-pin') &&
            !e.target.closest('.cp-globe-flag') &&
            typeof window.cpHomeGlobeClearFocus === 'function'
        ) {
            window.cpHomeGlobeClearFocus();
        }
    });

    if (detailsCloseBtn) {
        detailsCloseBtn.addEventListener('click', function () {
            closeDetailsModal();
        });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeDetailsModal();
        }
    });

    applyHiddenCardsToDom();
    applyHiddenMarkersFromStorage();

    document.addEventListener('cp:home-section-replaced', function () {
        applyHiddenCardsToDom();
        applyHiddenMarkersFromStorage();
        applyHomeFeedTypeVisibility();
        renderHiddenDropdowns();
        renderHiddenTypeBar();
        if (typeof window.cpHomeGlobeReload === 'function') {
            window.cpHomeGlobeReload();
        }
    });

    renderHiddenTypeBar();

    document.addEventListener('click', function (event) {
        var typeBtn = event.target.closest('.js-home-type-visibility');
        if (!typeBtn) return;

        event.preventDefault();
        var category = typeBtn.getAttribute('data-home-feed-type');
        var action = typeBtn.getAttribute('data-action') || 'hide';
        setHomeFeedTypeHidden(category, action === 'hide');
    });
})();
